import { rm, combineReducers } from 'utils';
import {
  BaseOrderLessInitialState,
  BaseOrderlessAction,
  BaseOrderlessState,
  baseFormReducer,
  baseOrderLessReducer
} from 'components/CustomerSupportForms/Utils';
import {
  ImageAction,
  ImageInitialState,
  ImageState,
  imagesReducer
} from '../Components/ImageUpload/ImageHelper';
import { isValidEmail } from 'components/Shared/Form';
import { isValidPhoneNumber } from 'views/CheckoutPage/validation';
import { isCustomerContactValid } from '../Components/CustomerContact/utils';

type InternalState = BaseOrderlessState &
  ImageState & {
    subject: string;
    question: string;
  };

export const productQuestionInitialState: InternalState = {
  ...BaseOrderLessInitialState,
  ...ImageInitialState,
  subject: '',
  question: ''
};

type Action =
  | { type: 'question'; value: string }
  | { type: 'subject'; value: string }
  | BaseOrderlessAction
  | ImageAction;

export const productQuestionReducer = (state: InternalState, action: Action): InternalState => {
  switch (action.type) {
    case 'subject':
      return { ...state, subject: action.value };
    case 'question':
      return { ...state, question: action.value };
    default:
      return state;
  }
};

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseOrderLessReducer,
  productQuestionReducer,
  imagesReducer
);

export const isValid = (state: InternalState, dispatch: (action: Action) => void) => {
  let isValid = true;
  const { name, subject, question, email, phone } = state;

  if (question === '' || subject === '' || email === '' || name === '' || phone === '') {
    dispatch({
      type: 'generalError',
      value: rm('CustomerService_Question_Product_Validation_Error')
    });
    isValid = false;
  }
  if (!isValidEmail(email) || !isValidPhoneNumber(phone)) {
    dispatch({
      type: 'addressError',
      value: rm('CustomerService_Quote_Request_Address_Validation_Error')
    });
    isValid = false;
  }

  isValid = isCustomerContactValid({ state, valid: isValid, dispatch });

  return isValid;
};
